'use strict'

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import es from 'vuetify/es5/locale/es'
import en from 'vuetify/es5/locale/en'
import store from '@/store'

Vue.use(Vuetify)
console.log(store.state)
export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: store.state.configColor.primary,
        secondary: store.state.configColor.secondary,
        third: '#4d4d4d',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  },
  lang: {
    locales: { es, en },
    current: process.env.VUE_APP_I18N_LOCALE
  },
  icons: {
    iconfont: 'fa'
  }
})
